import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProjectService from "../Services/ProjectService";
import "../CSS/EditProjectForm.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const EditProjectForm = ({ toggleSidebar, setRefreshProjects }) => {
  //  READ organizationId ALSO

  const { organizationId, projectId } = useParams();
  const navigate = useNavigate();

  const [project, setProject] = useState({
    name: "",
    description: "",
    localBasePath: "",
    serverBasePath: "",
    stageBasePath: ""
  });

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  //  FETCH PROJECT WITH organizationId
 useEffect(() => {
  if (!organizationId || !projectId) return; // ADD THIS GUARD

  const fetchProject = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await ProjectService.getProjectById(
        organizationId,
        projectId
      );

      setProject(response.data);
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Failed to load project details");
    } finally {
      setIsLoading(false);
    }
  };

  fetchProject();
}, [organizationId, projectId]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProject((prev) => ({ ...prev, [name]: value }));
  };

  // UPDATE PROJECT WITH organizationId
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setIsLoading(true);
    setError(null);

    const cleanedProject = {
  name: project.name,
  description: project.description,
  localBasePath: project.localBasePath || null,
  serverBasePath: project.serverBasePath || null,
  stageBasePath: project.stageBasePath || null
};

    await ProjectService.updateProject(
      organizationId,
      projectId,
      cleanedProject
    );

    toast.success("Project updated successfully");

setTimeout(() => {
  navigate(-1);
}, 300);




   setError(null);
// Close modal instead of navigating to same route


  } catch (error) {
    console.error("UPDATE ERROR:", error);
    setError("Failed to update project");
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  return () => {
    setError(null);
  };
}, []);

useEffect(() => {
  console.log("Component mounted");
}, []);


          console.log("Current error state:", error);


  return (
    <div className="edit-project-container">

      {/* CLOSE BUTTON */}
      <button
        className="close-btn"
        onClick={() =>
          navigate(`/organization/${organizationId}/project/${projectId}`)
        }
      >
        ✖
      </button>

      <button className="hamburger" onClick={toggleSidebar}>
        ☰
      </button>

      <h2>Edit Project</h2>

      {error && <div className="error-message">{error}</div>}

      {isLoading ? (
        <div className="loading-spinner">Loading...</div>
      ) : (
        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label>Project Name:</label>
            <input
              type="text"
              name="name"
              value={project.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Description:</label>
            <textarea
              name="description"
              value={project.description}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Local Base Path:</label>
            <input
              type="text"
              name="localBasePath"
value={project.localBasePath || ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Production Base Path:</label>
            <input
              type="text"
              name="serverBasePath"
value={project.serverBasePath || ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Stage Base Path:</label>
            <input
              type="text"
              name="stageBasePath"
value={project.stageBasePath || ""}
              onChange={handleInputChange}
            />
          </div>


          <div className="form-actions">
            <button type="submit" className="save-btn" disabled={isLoading}>
              {isLoading ? "Saving..." : "Save Changes"}
            </button>

            <button
              type="button"
              className="cancel-btn"
              onClick={() =>
                navigate(`/organization/${organizationId}/project/${projectId}`)
              }
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default EditProjectForm;
